<template>
	<div>
		<div class="row">
			<div class="col-md-12">
				<el-card shadow="hover">
					<div slot="header">
						<h5 class="text-center m-0 px-2">DO OS All Status per Region (YTD)</h5>
					</div>
					<div class="list-item-container px-2">
						<table class="table-outstanding-status-by-area" style="width: 100%;" cellpadding="2">
							<thead>
								<tr class="">
									<td class="py-2 text-muted">#</td>
									<td class="text-muted"><em>Region</em></td>
									<td class="text-right text-muted"><em>Delivered</em></td>
									<td class="text-right text-muted"><em>Outstanding</em></td>
									<td class="text-right text-muted"><em>Deleted</em></td>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in reportdata?.data" :key="item.RegionPertareId">
									<td class="py-2">{{ ++index }}</td>
									<td>{{ item.Label }}</td>
									<td class="text-right font-weight-bold">{{ formatNum(item.Delivered, 0) }}</td>
									<td class="text-right font-weight-bold">{{ formatNum(item.Outstanding, 0) }}</td>
									<td class="text-right font-weight-bold">{{ formatNum(item.Deleted, 0) }}</td>
								</tr>
								<tr>
									<td colspan="5">
										<hr />
									</td>
								</tr>
								<tr>
									<td class="py-2"></td>
									<td><strong>Total</strong></td>
									<td class="text-right font-weight-bold">{{ formatNum(totalDelivered, 0) }}</td>
									<td class="text-right font-weight-bold">{{ formatNum(totalOutstanding, 0) }}</td>
									<td class="text-right font-weight-bold">{{ formatNum(totalDeleted, 0) }}</td>
								</tr>
							</tbody>
						</table>
					</div>
					<Loader v-if="loading.table" />
				</el-card>
			</div>
		</div>
	</div>
</template>

<script>
import BarCard from '@/views/pages/BarCard.vue'
import ListItem from '@/views/pages/ListItem.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import Fuel from '@/components/page/Fuel.js'
import Footer from '@/views/Footer.vue'
import PieChart from '@/components/chart/Pie.js'
import { Rainbow, Rainbow3, Penanggalan, AppColors, Config, AxiosWithJar } from '@/utility.js'
import Loader from '@/components/loader/Loader2.vue'

export default{
	extends: Fuel,
	components:{
		Loader,
		//ListItem,
		//ListCompare,
		//BarCard,
		//PieChart,
		//Footer
	},
	data() {
		return {
			reportdata: [],
            value: 0,
			loading: {
				table: false,
				chart: false,
			},
		}
	},
	watch: {

	},
	computed: {
		totalDelivered() {
			return this.reportdata?.data?.reduce((sum, item) => sum + item.Delivered, 0);
		},
		totalOutstanding() {
			return this.reportdata?.data?.reduce((sum, item) => sum + item.Outstanding, 0);
		},
		totalDeleted() {
			return this.reportdata?.data?.reduce((sum, item) => sum + item.Deleted, 0);
		}
	},

    mounted() {
		this.getData();
    },
    methods:{
		async getData() {
			this.urlRequestParams = Config().apiURL
			this.urlRequestParams += '/v1/dooutstanding/allstatusbysalesarea?'
			this.urlRequestParams += '&region=region'

			/*
            this.urlRequestParams += '&plant='+this.plant
			this.urlRequestParams += '&station='+this.stationid
			this.urlRequestParams += '&type='+this.stationtype
			this.urlRequestParams += '&area='+this.area
			this.urlRequestParams += '&owner='+this.owner
			this.urlRequestParams += '&lokasi='+this.lokasi
			this.urlRequestParams += '&category='+this.category
			this.urlRequestParams += '&subcategory='+this.subcategory
			this.urlRequestParams += '&status='+this.status
			*/

            this.loading.table = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{
					this.loading.isSuccess = true;
					this.reportdata = response.data;

				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.table = false;
				})
        },
	}
}
</script>


<style>
.list-item-container {
    width: 100%;
    margin: 0 auto;
}

.list-item2 {
	display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
}

.list-item-label {
	width: 60%;
	text-align: left;
	font-weight: normal;
}

.table-outstanding-status-by-area tr td {
	padding: 10px 40x;
}
  </style>
